module.exports = __webpack_public_path__ + "static/media/logo_seguro_com_corretor.86a77961.jpeg";